import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function Button({
  children,
  type = 'button',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  icon,
  onClick,
  className = ''
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center border font-medium rounded-xl focus:outline-none transition-all duration-200 shadow-sm';
  const variantStyles = {
    primary: 'border-transparent text-white bg-[#7B68EE] hover:bg-[#6A5ADB] focus:ring-2 focus:ring-offset-2 focus:ring-[#7B68EE]',
    secondary: 'border-gray-200 text-gray-700 bg-white hover:bg-gray-50 focus:ring-2 focus:ring-offset-2 focus:ring-[#7B68EE]',
    tertiary: 'border-transparent text-[#7B68EE] bg-[#7B68EE]/10 hover:bg-[#7B68EE]/20 shadow-none',
    danger: 'border-transparent text-white bg-[#FF6B81] hover:bg-[#FF5972] focus:ring-2 focus:ring-offset-2 focus:ring-[#FF6B81]'
  };
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
  };
  const widthStyles = fullWidth ? 'w-full' : '';
  const styles = `
    ${baseStyles}
    ${variantStyles[variant]}
    ${sizeStyles[size]}
    ${widthStyles}
    ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
    ${className}
  `;
  return <button type={type} className={styles} disabled={disabled} onClick={onClick} data-id="element-1498">
      {icon && <span className="mr-2" data-id="element-1499">{icon}</span>}
      {children}
    </button>;
}